import { Box } from "@mui/material";
import { ReactNode } from "react";

interface TabProps {
  active?: boolean;
  onClick?: () => void;
  children: ReactNode;
}

// One button inside a SegmentedTabs group - visual language ported from the
// reference mockup's .seg/.seg button (a bordered, divided segmented group
// with a solid blue "on" state). Used for both the taxpayer-type tabs and
// the return-type sub tabs in place of the app-wide StyledProfileNav, which
// stays untouched everywhere else it's used.
export function SegmentedTab({ active, onClick, children }: TabProps) {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        border: 0,
        borderRight: "1px solid #e3e8f0",
        "&:last-of-type": { borderRight: 0 },
        bgcolor: active ? "#2563eb" : "#fff",
        color: active ? "#fff" : "#51607a",
        fontWeight: active ? 600 : 500,
        fontFamily: "inherit",
        fontSize: 12.5,
        lineHeight: 1.5,
        padding: "7px 13px",
        cursor: "pointer",
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </Box>
  );
}

interface GroupProps {
  children: ReactNode;
}

// The segmented group container - ported from the reference mockup's .seg.
export function SegmentedTabs({ children }: GroupProps) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        border: "1px solid #cbd5e1",
        borderRadius: "8px",
        overflow: "hidden",
        maxWidth: "100%",
      }}
    >
      {children}
    </Box>
  );
}
